import { supabase } from '../../lib/supabase';
import { throwWithContext } from './_shared';

export interface Announcement {
  id: string;
  version: number;
  eyebrow: string;
  title: string;
  body: string | null;
  imageUrl: string | null;
  ctaLabel: string | null;
  ctaPath: string | null;
  audience: string;
  createdAt: string;
}

/**
 * Fetches the highest-version active announcement, or null if none.
 * RLS already filters to `active = true` so this query just sorts and
 * limits to 1. The "audience" column is fetched but not yet acted on
 * client-side — leave it for when segmentation is needed.
 */
export async function fetchActiveAnnouncement(): Promise<Announcement | null> {
  const { data, error } = await supabase
    .from('app_announcements')
    .select('id, version, eyebrow, title, body, image_url, cta_label, cta_path, audience, created_at')
    .order('version', { ascending: false })
    .limit(1)
    .maybeSingle();

  if (error) {
    throwWithContext('Failed to fetch announcement', error);
  }
  if (!data) return null;

  return {
    id: data.id,
    version: data.version,
    eyebrow: data.eyebrow,
    title: data.title,
    body: data.body,
    imageUrl: data.image_url,
    ctaLabel: data.cta_label,
    ctaPath: data.cta_path,
    audience: data.audience,
    createdAt: data.created_at,
  };
}
